<app-config-editor-tree #configEditorTree [def]="def" [showInfoColumn]="false" [propColumnWidth]="'250px'">
</app-config-editor-tree>
